import { EmurseAppFactory, EmurseAppRegistration, EmurseStartup, type IAppData } from '@/EmurseStartup';
import FormApp from './Form.vue';
import { FormRepository } from '@/data/repository/FormRepository';
 
EmurseAppFactory.registerApp(new EmurseAppRegistration("form",(appData: IAppData)=>
{ 
  const startupData= {app: FormApp,
    appData:appData,
    repositories:{
      formRepository: FormRepository
    }}; 
  const startup = new EmurseStartup(startupData);
}));  